import { notification } from "antd";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../../Services/axiosCommon";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../Components/Utils/Buttons";
import CustomImgUpload from "../../../Components/Utils/CustomImgUpload";
import Breadcrumb from "../../../Components/Utils/Breadcrumb";
import Dashboard from "../Dashboard";
import {
  NuDate,
  NuInput,
  NuMobileNumber,
  NuSelect,
} from "../../../Components/Utils/Input";
import MultiSelect from "../../../Components/Utils/MultiSelect";
import FormikSelectTwo, {
  SelectCountry,
} from "../../../Components/Utils/Select";
import useAddFormData from "../../../Components/Hooks/useAddFormData";
import { TextMediumSM } from "../../../Components/Text/MediumText";
import { CountryMIN } from "../../../assets/CountryMini";
import DropDownAdd from "../../../Components/Utils/selectAdd";
import UseCatSubCatDropDown from "../../../Components/Hooks/useCategoryDropDown";
import useFetchMataData from "../../../Components/Hooks/useFetchMataData";

function CreateEmployee() {
  const { officeId } = useParams();
  const navigate = useNavigate();
  const { Oncancel, addFormData, isLoading } = useAddFormData();
  const { value: clientPosition } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "clientPosition"
  );
  const [image, setImage] = useState({ preview: "", raw: "" });
  const [projectList, setProjectList] = useState([]);
  const [api, contextHolder] = notification.useNotification();
  const [createNew, setCreateNew] = useState({
    name: "",
    email: "",
    branchId: officeId,
    country_code: "",
    mobileNo: "",
    gender: "",
    dob: "",
    currentProject: '', // projectId,
    projectWorked: "", //array[projectIds],
    emergencyMobileNo: "",
    position: "", // (Postion drop-down)
    address1: "",
    address2: "",
    state: "",
    city: "",
    country: "",
    pincode: "",
    emergencyName: "",
    emergencyRelationship: "",
    dateOfJoin: "",
    dateOfRelieving: "",
    nationalId: "",
    nationIdExpiryDate: "",
    passportNumber: "",
    passportExpiryDate: "",
    type: "",
    category: "",
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      mobileNo: yup
              .string()
              .matches(/^\d+$/, "Phone number must contain only digits")
              .min(9, "Phone number must be at least 9 digits")
              .max(11, "Phone number must be at most 11 digits")
              .required("Phone number is required"),
      email: yup.string().required("Email is required!"),
      name: yup.string().required("Name  is required!"),
      type: yup.string().required("Type  is required!"),
      // currentProject: yup.string().required("Current Project  is required!"),
      gender: yup.string().required("Gender  is required!"),



    }),
    onSubmit: async (value, { resetForm }) => {
      let newVal = {...value}
      let formData = new FormData();
      formData.append("json_data", JSON.stringify(newVal));
      formData.append("employeeImage", image.raw);
      addFormData("/employees/ ", formData, resetForm);
    },
  });
 const [inputKey, setInputKey] = useState(Date.now()); 

const handleChangeImg = (e) => {
    if (e.target.files.length) {
        setImage({
            preview: URL.createObjectURL(e.target.files[0]),
            raw: e.target.files[0],
        });
    }
};

const handleImageRemove = () => {
    setImage(
      { preview: "", raw: "" }
    );
    setInputKey(Date.now()); 
};
  const handleDeleteImg = () => {
    setImage({
      preview: "",
      raw: "",
    });
    setCreateNew((prevState) => ({ ...createNew, userImage: "" }));
    formik.values.userImage = "";
  };

  function getAllProject() {
    axiosInstance
      .get(`/DropDown/${officeId}/getAllProjects`)
      .then((res) => {
        let allProject = res.data?.data;
        let finalData = [];
        res.data?.data &&
          allProject.forEach((i) => {
            let x = {
              value: i.projId,
              label: i.projName,
            };
            finalData.push(x);
          });
        setProjectList(finalData);
      })
      .catch((error) => {
        console.error("Error fetching projects:", error);
      });
  }

  useEffect(() => {
    getAllProject();
  }, []);
  const {
    category: itemsCategory,
    subCategory: itemsSubCategory,
    getCategory,
    fetchSubCategory,
  } = UseCatSubCatDropDown(
    "/category/ItemCategory",
    "ItemCategory",
    formik?.values?.category
  );

  return (
    <div className=" w-full h-full py-2 px-4 ">
      {/* <div className=""> */}
      <div className="md:flex justify-end w-full">
        {/* <Breadcrumb
          items={[
            // { name: "Sales" },

            {
              name: "Employee",
              link: `/main/${officeId}/employees`,
            },

            { name: "Edit" },
          ]}
        /> */}
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-xl overflow-hidden mt-4">
          <div className=" w-full h-full flex justify-start content-start flex-wrap py-2 px-4  overflow-y-auto">
            <div className="w-full">
              <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                Personal Info :
              </p>
            </div>
            {/* <CustomImgUpload
              borderStyle="dashed"
              handleChange={handleChangeImg}
              label={"User Profile"}
              preview={image.preview || createNew.employeeImage || ""}
              removeFunction={handleDeleteImg}
            /> */}
            <CustomImgUpload
                                     key={inputKey}
                                        borderStyle="dashed"
              // label={"User Profile"}

                                        isRemove={true}
                                        removeFunction={handleImageRemove}
                                        handleChange={handleChangeImg}
                                        preview={image.preview || createNew.employeeImage || ""}
                                    />
            <NuInput
              type="text"
              label="Name"
              placeholder="Enter Name"
              formik={formik}
              name="name"
              isRequired={true}
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuInput
              type="email"
              label="Email"
              placeholder="Email"
              formik={formik}
              name="email"
              isRequired={true}
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuMobileNumber
              nunCode="country_code"
              label="Phone"
              placeholder="Phone"
              formik={formik}
              name="mobileNo"
              isRequired={true}
 FixPosition={true}
              PortalTarget={true}
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuDate
              label="DOB"
              placeholder="DOB"
              formik={formik}
              name="dob"
             
              width="w-full md:w-1/3 md:-mt-2"
            />
            <FormikSelectTwo
              label="Gender"
              Options={[
                { value: "M", label: "Male" },
                { value: "F", label: "Female" },
              ]}
              formik={formik}
              placeholder="Choose"
              name="gender"
              isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
            />
            <FormikSelectTwo
              label="Type"
              Options={[
                { value: 1, label: "Own" },
                { value: 2, label: "Rental" },
              ]}
              formik={formik}
              placeholder="Choose"
              name="type"
              isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
            />
            <DropDownAdd
              type="text"
              label="Category"
              placeholder="Category"
              Options={itemsCategory}
              formik={formik}
              name="category"
              width="w-full md:w-1/3 md:-mt-2"
              getFunc={getCategory}
              categoryName={"ItemCategory"}
              displayProperty={"Add Category"}
              FixPosition={true}
              PortalTarget={false}
              // isRequired={true}
            />
             <div className="w-full">
              <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                Employee Roll :
              </p>
            </div>
            <FormikSelectTwo
              type="text"
              label="Position"
              placeholder="Choose"
              Options={clientPosition}
              formik={formik}
              name="position"
              width="w-full md:w-1/3 md:-mt-2"
            />

            <MultiSelect
              label="Assigned Project"
              Options={projectList}
              formik={formik}
              placeholder="Choose"
              // isRequired={true}
              name="currentProject"
              width="w-full md:w-1/3 md:-mt-2"
            />
            {/* <MultiSelect
              label="Assigned Project"
              Options={projectList}
              formik={formik}
              placeholder="Choose"
              // isRequired={true}
              name="projectWorked"
              width="w-full md:w-1/3 md:-mt-2"
            /> */}

            <div className="w-full">
              <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
              Emergency Info :
              </p>
            </div>
            <NuInput
              type="text"
              label="Emergency Name"
              placeholder="Enter Name"
              formik={formik}
              name="emergencyName"
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuInput
              // nunCode="countryCode"
              label="Emergency Mobile No"
              placeholder="Emergency Mobile No"
              formik={formik}
              name="emergencyMobileNo"
              width="w-full md:w-1/3 md:-mt-2"
            />
            <FormikSelectTwo
              label="Relationship"
              Options={[
                { value: "Father", label: "Father" },
                { value: "Mother", label: "Mother" },
                { value: "Brother", label: "Brother" },
                { value: "Sister", label: "Sister" },
              ]}
              formik={formik}
              placeholder="Choose"
              name="emergencyRelationship"
              width="w-full md:w-1/3 md:-mt-2 "
            />
            <NuDate
              label="Date Of Join"
              placeholder="Date Of Join"
              formik={formik}
              name="dateOfJoin"
             
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuDate
              label="Date Of Relieving"
              placeholder="Date Of Relieving"
              formik={formik}
              name="dateOfRelieving"
              
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuInput
              label="National Id"
              placeholder="National Id"
              formik={formik}
              name="nationalId"
              width="w-full md:w-1/3 md:-mt-2 "
            />
            <NuDate
              label="National-Id Expiry Date"
              placeholder="NationId Expiry Date"

              formik={formik}
              name="nationIdExpiryDate"
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuInput
              label="Passport Number"
              placeholder="Passport Number"
              formik={formik}
              name="passportNumber"
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuDate
              label="Passport Expiry Date"
              placeholder="Passport Expiry Date"

              formik={formik}
              name="passportExpiryDate"
              width="w-full md:w-1/3 md:-mt-2"
            />
           
            <div className="w-full">
              <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                Address :
              </p>
            </div>
            <NuInput
              type="text"
              label="Street Address Line 1"
              placeholder="Street Address Line 1"
              formik={formik}
              name="address1"
              width="w-full md:w-1/3 md:-mt-2 lg:w-1/3"
            />

            <NuInput
              type="text"
              label="Street Address Line 2"
              placeholder="Street Address Line 2"
              formik={formik}
              name="address2"
              width="w-full md:w-1/3 md:-mt-2 lg:w-1/3"
            />

            <NuInput
              type="text"
              label="City"
              placeholder="Enter City"
              formik={formik}
              name="city"
              width="w-full md:w-1/3 md:-mt-2"
            />

            <NuInput
              type="text"
              label="State"
              placeholder="Enter State"
              formik={formik}
              name="state"
              width="w-full md:w-1/3 md:-mt-2"
            />
            <FormikSelectTwo
              type="text"
              label="Country"
              placeholder="Country"
              Options={CountryMIN}
              formik={formik}
              name="country"
              width="w-full md:w-1/3 md:-mt-2"
              FixPosition={true}
              PortalTarget={true}
            />

            <NuInput
              type="number"
              label="Zip Code"
              placeholder="Type Here"
              formik={formik}
              name="pincode"
              width="w-full md:w-1/3 md:-mt-2"
            />

            <div className="w-full mx-auto my-4 mt-8 ">
              <div className="flex justify-end gap-4">
                <CancelButton
                  handleClick={() => {
                    navigate(-1);
                  }}
                />
                <SubmitButton />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default CreateEmployee;
